const devConfig = {
    backend:
        {
            url:"http://localhost:8080"
        },
    keycloak: {
        savurl: "http://localhost:7080", // URL Keycloak local pour le développement
        url: "https://auth.racegroup.fr",   // URL Keycloak pour la production
        realm: "racegroup",                // Realm de développement
        clientId: "whatsappapi",         // Client ID de développement
    },
    environment: "development",           // Nom de l'environnement
    debug: true,                          // Activer le debug pour le développement
};

const prodConfig = {
    backend : {
        url:"https://nsbgsracegroupdbffudct-whatsappapi-backend.functions.fnc.fr-par.scw.cloud"
    },
    keycloak: {
        url: "https://auth.racegroup.fr",   // URL Keycloak pour la production
        realm: "racegroup",                 // Realm de production
        clientId: "whatsappapi",            // Client ID de production
    },
    environment: "production",                   // Nom de l'environnement
    debug: false,                                // Désactiver le debug pour la production
};

// Déterminer l'environnement en fonction de NODE_ENV
const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig;
// const config = devConfig;
export default config;
